import Swal from "sweetalert2";

export default class ErrorService {
  constructor() {}

  static error(message, title) {
    let options = {type: 'error'}
    if (title) options.title = title
    if (message) options.html = message
    Swal.fire(options)
  }
}



// WEBPACK FOOTER //
// ./src/Services/ErrorService.js